module.exports = __webpack_public_path__ + "static/media/IMPORT_BULK_UPLOAD_3.00.8fa2aa1a.xlsx";